<template>
    <div>
        <div class="midcontent">
            <img class="bgimg" src="../../assets/images/home/fxjc/bjt2.png"/>
            <div class="contentdiv">
                <div class="leftbox">
                    <div class="leftrow0">财税体检</div>
                    <div class="leftrow1">「 专业检测模型 · 智能风险预警 」</div>
                    <div class="leftrow2">您的财税风险管理专家先知、可控、安全、陪伴</div>
                    <div class="leftrow3">
                        <Button
                                class="button"
                                @click="gotoIndex"
                                type="primary"
                                size="large"
                                shape="circle"
                        >立即检测
                        </Button
                        >
                    </div>
                </div>
                <div class="rightimgbox">
                    <img src="../../assets/images/home/fxjc/bannerdl2.png" height="100%"/>
                </div>
                <div style="flex: 1"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        created() {
            console.log("second.vue created==>")
        },
        methods: {
            gotoIndex() {
                //this.$router.push("/fxjc");
                this.$router.push({ name: 'riskdetection' })
            },
        },
        data() {
            return {
                showHome: false,
                modalStateMent: false,
                carouselValue: 0,
                value: 0
            }
        },
        beforeCreate() {
            
        },
    }
</script>
<style scoped>

    .midcontent {
        display: flex;
        flex: 8;
        justify-content: center;
        position: relative;
        overflow-y: hidden;
        min-width: 1250px;
    }

    .contentdiv {
        position: absolute;
        top: 15%;
        z-index: 99;
        width: 80%;
        display: flex;
        flex-direction: row;
    }

    .rightimgbox {
        flex: 3;
        display: flex;
        justify-content: center;
    }

    .leftbox {
        flex: 6;
        display: flex;
        flex-direction: column;
    }

    .leftrow0 {
        flex: 1;
        font-family: YouSheBiaoTiHei;
        font-size: 80px;
        color: white;
        text-shadow: 0 2px 4px #ffffff80;
        font-weight: 600;
    }

    .leftrow1 {
        flex: 0.8;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        color: white;
    }

    .leftrow2 {
        flex: 1;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: white;
    }

    .leftrow3 {
        flex: 0.8;
    }

    .button {
        width: 200px;
        height: 48px;
        background-color: #0FD9F7;
        border-radius: 8px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }


    .bgimg {
        width: 100%;
        height: calc(100vh - 128px); /* 减去导航栏高度 */;
        min-height: 600px; /* 保证最小高度 */
        object-fit: cover;
        object-position: center;
        z-index: 5;
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
        .bgimg {
            min-height: 300px; /* 移动端高度适当减小 */
        }
    }


</style>
